import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpService } from '../http.service';
import { HttpRequestHandler } from '../../models/http-model';
const HEADERS = {};

@Injectable()
export class ReportsService {

  static ENV = environment;

  constructor(private httpService: HttpService) {
    HEADERS['Content-Type'] = 'application/json';
  }

  public getReportAuxiliaryByNit( data: any, httpRequesthandler: HttpRequestHandler ): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(ReportsService.ENV.environment.API.get_report_by_nit, data, httpRequesthandler);
  }
  public getReportBalancethirdA( data: any, httpRequesthandler: HttpRequestHandler ): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(ReportsService.ENV.environment.API.get_balance_third_acum, data, httpRequesthandler);
  }

}



// WEBPACK FOOTER //
// ./src/app/core/services/reports/reports.service.ts